module.exports = __webpack_public_path__ + "img/1024.f8513cb9.svg";